<template>
  <div :class="['message-cloud', { answer : answer }]">
    <template
      v-if="!answer"
    >
      <div class="message-cloud__body-item">
        <span class="message-cloud__body-key">
          Размер:
        </span>
        <span class="message-cloud__body-value">
          {{ size }}
        </span>
      </div>
      <div class="message-cloud__body-item">
        <span class="message-cloud__body-key">
          Достоинства:
        </span>
        <span class="message-cloud__body-value">
          {{ pros }}
        </span>
      </div>
      <div>
        <span class="message-cloud__body-key">
          Недостатки:
        </span>
        <span class="message-cloud__body-value">
          {{ cons }}
        </span>
      </div>
    </template>

    <div class="message-cloud__text message-cloud__body-value">
      {{ text }}
    </div>

    <div
      v-if="$slots.default"
      class="message-cloud__answers">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "message-cloud",

  props: {
    size: {
      type: String,
      default: '',
    },
    pros: {
      type: String,
      default: '',
    },
    cons: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      required: true,
    },
    answer: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style lang="scss">
  .message-cloud {
    background: $blue_8;
    border-radius: 4px 16px 16px 16px;
    padding: 16px;

    @include breakpoint("desktop") {
      padding: 36px;
    }

    &.answer {
      background: none;
      padding: 0;
      border-radius: 0;
    }

    &__body-item {
      margin-bottom: 4px;
    }

    &__body-value,
    &__body-key {
      font-size: 14px;
      line-height: 20px;

      @include breakpoint("desktop") {
        font-size: 16px;
        line-height: 24px;
      }
    }

    &__body-key {
      font-weight: bold;
    }

    &__text {
      margin-top: 8px;

      @include breakpoint("desktop") {
        margin-top: 16px;
      }
    }

    &__answers {
      .product-review-answer {
        margin-top: 16px;

        @include breakpoint("desktop") {
          margin-top: 32px;
        }
      }
    }
  }
</style>